import { isWeb } from '@gluestack-ui/nativewind-utils/IsWeb';

import { ContentLibrary } from '@/components/contentLibrary';
import { Library } from '@/components/library';

export default () => (isWeb ? <ContentLibrary /> : <Library initialTab="contentLibrary" />);
